import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import { Error } from '../_models/auth.models';
import { Field } from '../_models/field.model';
import {
  CalendarData,
  CalendarReportPayload,
  ChartType,
  Column,
  CopyReportPayload,
  CopyReportResponse,
  CreateDatatablePayload,
  CreateGanttPayload,
  Datatable,
  FlexBoundaryCheck,
  FlexBoundaryCheckResponse,
  FlexDataRequest,
  GanttData,
  IUpdateDefaultReport,
  MapData,
  MapReportPayload,
  Report,
  ReportDetails,
  ReportWFilter,
  RequestDatatable,
  Summary,
  UpdateDatatablePayload,
  UpdateGanttPayload,
} from '../_models/report.models';
import {
  LoadSummaryFieldsFailed,
  LoadSummaryFieldsSuccess,
} from './field.actions';

/**
 * Reprt action types
 */
export enum ReportActionTypes {
  LOAD_REPORTS = '[Report] Load Reports',
  LOAD_REPORTS_SUCCESS = '[Report] Load Reports Success',
  LOAD_REPORTS_FAILED = '[Report] Load Reports Failed',
  LOAD_REPORT_FIELDS = '[Report] Load Report Fields',
  LOAD_REPORT_FIELDS_SUCCESS = '[Report] Load Report Fields Success',
  LOAD_REPORT_FIELDS_FAILED = '[Report] Load Report Fields Failed',
  CREATE_DT_REPORT = '[Report] Create Report',
  CREATE_DT_REPORT_SUCCESS = '[Report] Create Report Success',
  CREATE_DT_REPORT_FAILED = '[Report] Create Report Failed',
  UPDATE_DT_REPORT = '[Report] Update Report',
  UPDATE_DT_REPORT_SUCCESS = '[Report] Update Report Success',
  UPDATE_DT_REPORT_FAILED = '[Report] Update Report Failed',
  CREATE_GANTT_REPORT = '[Report] Create Gantt Report',
  CREATE_GANTT_REPORT_SUCCESS = '[Report] Create Gantt Report Success',
  CREATE_GANTT_REPORT_FAILED = '[Report] Create Gantt Report Failed',
  UPDATE_GANTT_REPORT = '[Report] Update Gantt Report',
  UPDATE_GANTT_REPORT_SUCCESS = '[Report] Update Gantt Report Success',
  UPDATE_GANTT_REPORT_FAILED = '[Report] Update Gantt Report Failed',
  DELETE_REPORT = '[Report] Delete Report',
  DELETE_REPORT_SUCCESS = '[Report] Delete Report Success',
  DELETE_REPORT_FAILED = '[Report] Delete Report Failed',
  LOAD_REPORT_W_FILTERS = '[Report] Load Report With Filters',
  LOAD_REPORT_W_FILTERS_SUCCESS = '[Report] Load Report With Filters Success',
  LOAD_REPORT_W_FILTERS_FAILED = '[Report] Load Report With Filters Failed',
  LOAD_DATATABLE = '[Report] Load Datatable',
  LOAD_DATATABLE_SUCCESS = '[Report] Load Datatable Success',
  LOAD_DATATABLE_FAILED = '[Report] Load Datatable Failed',
  LOAD_FLEXDATA = '[Report] Load Flexdata',
  LOAD_FLEXDATA_SUCCESS = '[Report] Load Flexdata Success',
  LOAD_FLEXDATA_FAILED = '[Report] Load Flexdata Failed',
  LOAD_SUMMARY_REPORT = '[Report] Load Summary Report Field',
  LOAD_SUMMARY_REPORT_SUCCESS = '[Report] Load Summary Report Field Success',
  LOAD_SUMMARY_REPORT_FAILED = '[Report] Load Summary Report Field Failed',
  LOAD_FLEX_CHART_TYPES = '[Report] Load Flex Chart Types',
  LOAD_FLEX_CHART_TYPES_SUCCESS = '[Report] Load Flex Chart Types Success',
  LOAD_FLEX_CHART_TYPES_FAILED = '[Report] Load Flex Chart Types Failed',
  LOAD_DETAILS = '[Report] Load Details',
  LOAD_DETAILS_SUCCESS = '[Report] Load Details Success',
  LOAD_DETAILS_FAILED = '[Report] Load Details Failed',
  LOAD_COLUMNS = '[Report] Load Columns',
  LOAD_COLUMNS_SUCCESS = '[Report] Load Columns Success',
  LOAD_COLUMNS_FAILED = '[Report] Load Columns Failed',
  UPDATE_DEFAULT_REPORT = '[Report] Update Default Report',
  UPDATE_DEFAULT_REPORT_SUCCESS = '[Report] Update Default Report Success',
  UPDATE_DEFAULT_REPORT_FAILED = '[Report] Update Default Report Failed',

  CREATE_CALENDAR_REPORT = '[Report] Create Calendar Report',
  CREATE_CALENDAR_REPORT_SUCCESS = '[Report] Create Calendar Report Success',
  CREATE_CALENDAR_REPORT_FAILED = '[Report] Create Calendar Report Failed',
  UPDATE_CALENDAR_REPORT = '[Report] Update Calendar Report',
  UPDATE_CALENDAR_REPORT_SUCCESS = '[Report] Update Calendar Report Success',
  UPDATE_CALENDAR_REPORT_FAILED = '[Report] Update Calendar Report Failed',
  LOAD_CALENDAR_DATA = '[Report] Load Calendar Data',
  LOAD_CALENDAR_DATA_SUCCESS = '[Report] Load Calendar Data Success',
  LOAD_CALENDAR_DATA_FAILED = '[Report] Load Calendar Data Failed',
  LOAD_MAP_DATA = '[Report] Load Map Data',
  LOAD_MAP_DATA_SUCCESS = '[Report] Load Map Data Success',
  LOAD_MAP_DATA_FAILED = '[Report] Load Map Data Failed',
  LOAD_GANTT_DATA = '[Report] Load Gantt Data',
  LOAD_GANTT_DATA_SUCCESS = '[Report] Load Gantt Data Success',
  LOAD_GANTT_DATA_FAILED = '[Report] Load Gantt Data Failed',
  CREATE_MAP_REPORT = '[Report] Create Map Report',
  CREATE_MAP_REPORT_SUCCESS = '[Report] Create Map Report Success',
  CREATE_MAP_REPORT_FAILED = '[Report] Create Map Report Failed',
  UPDATE_MAP_REPORT = '[Report] Update Map Report',
  UPDATE_MAP_REPORT_SUCCESS = '[Report] Update Map Report Success',
  UPDATE_MAP_REPORT_FAILED = '[Report] Update Map Report Failed',
  LOAD_MAP_REPORT = '[Report] Load Map Report',
  LOAD_MAP_REPORT_SUCCESS = '[Report] Load Map Report Success',
  LOAD_MAP_REPORT_FAILED = '[Report] Load Map Report Failed',
  LOAD_MAP_FILTER_FIELDS = '[Report] Load Map Filter Fields',
  LOAD_MAP_FILTER_FIELDS_SUCCESS = '[Report] Load Map Filter Fields Success',
  LOAD_MAP_FILTER_FIELDS_FAILED = '[Report] Load Map Filter Fields Failed',

  COPY_REPORT = '[Report] Copy Report',
  COPY_REPORT_SUCCESS = '[Report] Copy Report Success',
  COPY_REPORT_FAILED = '[Report] Copy Report Failed',

  LOAD_FLEX_BOUNDARY_CHECK = '[Report] Flex Boundary Check',
  LOAD_FLEX_BOUNDARY_CHECK_SUCCESS = '[Report] Flex Boundary Check Success',
  LOAD_FLEX_BOUNDARY_CHECK_FAILED = '[Report] Flex Boundary Check Failed',

  LOAD_FLEXDATA_REQUEST = '[Report] Load Flexdata Request',
  LOAD_FLEXDATA_REQUEST_SUCCESS = '[Report] Load Flexdata Request Success',
  LOAD_FLEXDATA_REQUEST_FAILED = '[Report] Load Flexdata Request Failed',

  CREATE_TRAIN_MODEL = '[Report] Create Train Model',
  CREATE_TRAIN_MODEL_SUCCESS = '[Report] Create Train Model Success',
  CREATE_TRAIN_MODEL_FAILED = '[Report] Create Train Model Failed',

  GET_TRAINED_MODEL_RESULTS = '[Report] Get Train Model Results',
  GET_TRAINED_MODEL_RESULTS_SUCCESS = '[Report] Get Train Model Results Success',
  GET_TRAINED_MODEL_RESULTS_FAILED = '[Report] Get Train Model Results Error',

  PREDICT_ML_TRAINED_MODEL = '[Report] Predict Ml trained model',
  PREDICT_ML_TRAINED_MODEL_SUCCESS = '[Report] Predict Ml Trained Model Success',
  PREDICT_ML_TRAINED_MODEL_FAILED = '[Report] Predict Ml Trained Model Error',

  CREATE_COMP_VISION_MODEL = '[Report] Create Comp Vision Model',
  CREATE_COMP_VISION_MODEL_SUCCESS = '[Report] Create Comp Vision Model Success',
  CREATE_COMP_VISION_MODEL_FAILED = '[Report] Create Comp Vision Model Failed',

  PREDICT_COMP_VISION_MODEL = '[Report] Predict Comp Vision Model',
  PREDICT_COMP_VISION_MODEL_SUCCESS = '[Report] Predict Comp Vision Model Success',
  PREDICT_COMP_VISION_MODEL_FAILED = '[Report] Predict Comp Vision Model Failed',

  Get_CHAT_MESSAGE = '[Report] Get Chat Message Model',
  Get_CHAT_MESSAGE_SUCCESS = '[Report] Get Chat Message Model Success',
  Get_CHAT_MESSAGE_FAILED = '[Report] Get Chat Message Model Failed',

  Get_CHAT_PDF = '[Report] Get Chat Pdf Model',
  Get_CHAT_PDF_SUCCESS = '[Report] Get Chat Pdf Model Success',
  Get_CHAT_PDF_FAILED = '[Report] Get Chat Pdf Model Failed',

  FUZZY_MATCH = '[Report] Fuzzy Match Bot',
  FUZZY_MATCH_SUCCESS = '[Report] Fuzzy Match Bot Success',
  FUZZY_MATCH_FAILED = '[Report] Fuzzy Match Bot Failed',

  CLOSE_CHAT_BOT = '[Report] Close Chat Bot',
  CLOSE_CHAT_BOT_SUCCESS = '[Report] Close Chat Bot Success',
  CLOSE_CHAT_BOT_FAILED = '[Report] Close Chat Bot Failed',

  CLOSE_CHAT_PDF = '[Report] Close Chat Pdf',
  CLOSE_CHAT_PDF_SUCCESS = '[Report] Close Chat Pdf Success',
  CLOSE_CHAT_PDF_FAILED = '[Report] Close Chat Pdf Failed',
  SAVE_DEPENDENCY_LINKS = '[Report] Save Dependency Links',
  SAVE_DEPENDENCY_LINKS_SUCCESS = '[Report] Save Dependency Links Success',
  SAVE_DEPENDENCY_LINKS_FAILED = '[Report] Save Dependency Links Failed',
  SAVE_GANTT_BASELINES = '[Report] Save Gantt Baselines',
  SAVE_GANTT_BASELINES_SUCCESS = '[Report] Save Gantt Baselines Success',
  SAVE_GANTT_BASELINES_FAILED = '[Report] Save Gantt Baselines Failed',
  BULK_UPDATE_REPORTS = '[Report] Bulk Update Reports',
  BULK_UPDATE_REPORTS_SUCCESS = '[Report] Bulk Update Reports Success',
  BULK_UPDATE_REPORTS_FAILED = '[Report] Bulk Update Reports Failed',

  RESET = '[Navigation] RESET',
}

/**
 * Operations
 */
export class LoadReports implements Action {
  readonly type = ReportActionTypes.LOAD_REPORTS;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public tableId: string,
    public inForms: boolean = false,
    public formId: string = '',
    public formType: string = '',
    public fromTableSettings: boolean = false,
    public force: boolean = false
  ) {}
}

export class LoadReportsSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_REPORTS_SUCCESS;

  constructor(public tableId: string, public payload: Array<Report>) {}
}

export class LoadReportsFailed implements Action {
  readonly type = ReportActionTypes.LOAD_REPORTS_FAILED;

  constructor(public payload: Error, public tableId: string = '') {}
}

export class LoadReportFields implements Action {
  readonly type = ReportActionTypes.LOAD_REPORT_FIELDS;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public tableId: string, public force: boolean = false) {}
}

export class LoadReportFieldsSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_REPORT_FIELDS_SUCCESS;

  constructor(public tableId: string, public payload: Array<Field>) {}
}

export class LoadReportFieldsFailed implements Action {
  readonly type = ReportActionTypes.LOAD_REPORT_FIELDS_FAILED;

  constructor(public payload: Error, public tableId: string = '') {}
}

export class CreateDTReport extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_DT_REPORT;

  constructor(public tableId: string, public payload: CreateDatatablePayload) {
    super();
  }
}

export class CreateDTReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_DT_REPORT_SUCCESS;

  constructor(public tableId: string, public payload: Report) {
    super();
  }
}

export class CreateDTReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_DT_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdateDTReport extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_DT_REPORT;

  constructor(public reportId: string, public payload: UpdateDatatablePayload) {
    super();
  }
}

export class UpdateDTReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_DT_REPORT_SUCCESS;

  constructor(public reportId: string, public payload: Report) {
    super();
  }
}

export class UpdateDTReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_DT_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class CreateGanttReport extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_GANTT_REPORT;

  constructor(public tableId: string, public payload: CreateGanttPayload) {
    super();
  }
}

export class CreateGanttReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_GANTT_REPORT_SUCCESS;

  constructor(public tableId: string) {
    super();
  }
}

export class CreateGanttReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_GANTT_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdateGanttReport extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_GANTT_REPORT;

  constructor(public reportId: any, public payload: UpdateGanttPayload) {
    super();
  }
}

export class UpdateGanttReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_GANTT_REPORT_SUCCESS;

  constructor(public reportId: string) {
    super();
  }
}

export class UpdateGanttReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_GANTT_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadReportWithFilters implements Action {
  readonly type = ReportActionTypes.LOAD_REPORT_W_FILTERS;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public reportId: any, public force: boolean = false) {}
}

export class LoadReportWithFiltersSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_REPORT_W_FILTERS_SUCCESS;

  constructor(public reportId: string, public payload: ReportWFilter) {}
}

export class LoadReportWithFiltersFailed implements Action {
  readonly type = ReportActionTypes.LOAD_REPORT_W_FILTERS_FAILED;

  constructor(public payload: Error) {}
}

export class DeleteReport extends Reference implements Action {
  readonly type = ReportActionTypes.DELETE_REPORT;

  constructor(public tableId: string, public reportId: any) {
    super();
  }
}

export class DeleteReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.DELETE_REPORT_SUCCESS;

  constructor(public tableId: string, public reportId: any) {
    super();
  }
}

export class DeleteReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.DELETE_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadDatatable implements Action {
  readonly type = ReportActionTypes.LOAD_DATATABLE;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public tableId: string,
    public reportId: string,
    public payload: RequestDatatable,
    public fromDashboard: boolean = false,
    public force: boolean = false
  ) {}
}

export class LoadDatatableSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_DATATABLE_SUCCESS;

  /**
   * @param start start from (from request payload)
   * @param length page size (from request payload)
   */
  constructor(
    public tableId: string,
    public reportId: string,
    public start: number,
    public length: number,
    public payload: Datatable
  ) {}
}

export class LoadDatatableFailed implements Action {
  readonly type = ReportActionTypes.LOAD_DATATABLE_FAILED;

  constructor(public payload: Error) {}
}

export class LoadFlexdata implements Action {
  readonly type = ReportActionTypes.LOAD_FLEXDATA;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public tableId: string,
    public reportId: string = '0',
    public create: boolean = false,
    public edit: boolean = false,
    public fromDashboard: boolean = false,
    public force: boolean = false
  ) {}
}

export class LoadFlexdataSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_FLEXDATA_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string = '0',
    public payload: Array<Array<any>>
  ) {}
}

export class LoadFlexdataFailed implements Action {
  readonly type = ReportActionTypes.LOAD_FLEXDATA_FAILED;

  constructor(public payload: Error) {}
}

export class LoadSummaryReport implements Action {
  readonly type = ReportActionTypes.LOAD_SUMMARY_REPORT;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public tableId: string,
    public reportId: string,
    public fromDashboard: boolean = false,
    public force: boolean = false
  ) {}
}

export class LoadSummaryReportSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_SUMMARY_REPORT_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public payload: Summary
  ) {}
}

export class LoadSummaryReportFailed implements Action {
  readonly type = ReportActionTypes.LOAD_SUMMARY_REPORT_FAILED;

  constructor(public payload: Error, public tableId: string = '') {}
}

export class LoadFlexChartTypes implements Action {
  readonly type = ReportActionTypes.LOAD_FLEX_CHART_TYPES;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public force: boolean = false) {}
}

export class LoadFlexChartTypesSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_FLEX_CHART_TYPES_SUCCESS;

  constructor(public payload: Array<ChartType>) {}
}

export class LoadFlexChartTypesFailed implements Action {
  readonly type = ReportActionTypes.LOAD_FLEX_CHART_TYPES_FAILED;

  constructor(public payload: Error) {}
}

export class LoadDetails extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_DETAILS;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public tableId: string,
    public reportId: string,
    public recordId: number,
    public summaryFieldId: number | null = null,
    public force: boolean = false,
    public formId: string | null = null,
    public fromProcess: boolean = false,
    public fromRecordEdit: boolean = false,
  ) {
    super();
  }
}

export class LoadDetailsSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_DETAILS_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public recordId: number,
    public payload: ReportDetails
  ) {
    super();
  }
}

export class LoadDetailsFailed extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_DETAILS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadColumns implements Action {
  readonly type = ReportActionTypes.LOAD_COLUMNS;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public tableId: string,
    public id: string,
    public fromDashboard: boolean = false,
    public force: boolean = false
  ) {}
}

export class LoadColumnsSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_COLUMNS_SUCCESS;

  constructor(
    public tableId: string,
    public id: string,
    public payload: Array<Column>
  ) {}
}

export class LoadColumnsFailed implements Action {
  readonly type = ReportActionTypes.LOAD_COLUMNS_FAILED;

  constructor(public payload: Error) {}
}

export class UpdateDefaultReport implements Action {
  readonly type = ReportActionTypes.UPDATE_DEFAULT_REPORT;

  constructor(public payload: IUpdateDefaultReport) {}
}

export class UpdateDefaultReportSuccess implements Action {
  readonly type = ReportActionTypes.UPDATE_DEFAULT_REPORT_SUCCESS;
}

export class UpdateDefaultReportFailed implements Action {
  readonly type = ReportActionTypes.UPDATE_DEFAULT_REPORT_FAILED;

  constructor(public payload: Error) {}
}

export class CreateCalendarReport extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_CALENDAR_REPORT;

  constructor(public tableId: string, public payload: CalendarReportPayload) {
    super();
  }
}

export class CreateCalendarReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_CALENDAR_REPORT_SUCCESS;

  constructor(public tableId: string) {
    super();
  }
}

export class CreateCalendarReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_CALENDAR_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdateCalendarReport extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_CALENDAR_REPORT;

  constructor(public tableId: string, public payload: CalendarReportPayload) {
    super();
  }
}

export class UpdateCalendarReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_CALENDAR_REPORT_SUCCESS;

  constructor(public tableId: string) {
    super();
  }
}

export class UpdateCalendarReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_CALENDAR_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadCalendarData implements Action {
  readonly type = ReportActionTypes.LOAD_CALENDAR_DATA;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public tableId: string,
    public reportId: string,
    public fromDashboard: boolean = false,
    public isEmbeddedReport: boolean = false,
    public referenceFieldKey: string = '',
    public lookupFieldValue: string = '',
    public force: boolean = false
  ) {}
}

export class LoadCalendarDataSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_CALENDAR_DATA_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public payload: CalendarData
  ) {}
}

export class LoadCalendarDataFailed implements Action {
  readonly type = ReportActionTypes.LOAD_CALENDAR_DATA_FAILED;

  constructor(public payload: Error) {}
}

export class CreateMapReport extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_MAP_REPORT;

  constructor(public tableId: string, public payload: MapReportPayload) {
    super();
  }
}

export class CreateMapReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_MAP_REPORT_SUCCESS;

  constructor(public tableId: string) {
    super();
  }
}

export class CreateMapReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.CREATE_MAP_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdateMapReport extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_MAP_REPORT;

  constructor(public tableId: string, public payload: MapReportPayload) {
    super();
  }
}

export class UpdateMapReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_MAP_REPORT_SUCCESS;

  constructor(public tableId: string) {
    super();
  }
}

export class UpdateMapReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.UPDATE_MAP_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadSeriesFields extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_MAP_FILTER_FIELDS;

  constructor(public tableId: string) {
    super();
  }
}

export class LoadSeriesFieldsSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_MAP_FILTER_FIELDS_SUCCESS;

  constructor(public tableId: string,public payload:any) {
    super();
  }
}

export class LoadSeriesFieldsFailed extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_MAP_FILTER_FIELDS_FAILED;

  constructor(public payload: Error, public tableId: string) {
    super();
  }
}

export class LoadMapData implements Action {
  readonly type = ReportActionTypes.LOAD_MAP_DATA;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public tableId: any,
    public reportId: any,
    public fromDashboard: boolean = false,
    public force: boolean = false,
    public conditions?:any
  ) {}
}

export class LoadMapDataSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_MAP_DATA_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public payload: MapData
  ) {}
}

export class LoadMapDataFailed implements Action {
  readonly type = ReportActionTypes.LOAD_MAP_DATA_FAILED;

  constructor(public payload: Error) {}
}

export class LoadGanttData implements Action {
  readonly type = ReportActionTypes.LOAD_GANTT_DATA;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public tableId: string,
    public reportId: string,
    public fromDashboard: boolean = false,
    public isEmbeddedReport: boolean = false,
    public referenceFieldKey: string = '',
    public lookupFieldValue: string = '',
    public force: boolean = false
  ) {}
}

export class LoadGanttDataSuccess implements Action {
  readonly type = ReportActionTypes.LOAD_GANTT_DATA_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public payload: GanttData
  ) {}
}

export class LoadGanttDataFailed implements Action {
  readonly type = ReportActionTypes.LOAD_GANTT_DATA_FAILED;

  constructor(public payload: Error) {}
}

export class CopyReport extends Reference implements Action {
  readonly type = ReportActionTypes.COPY_REPORT;

  constructor(public tableId: string, public payload: CopyReportPayload) {
    super();
  }
}

export class CopyReportSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.COPY_REPORT_SUCCESS;

  constructor(public payload: CopyReportResponse) {
    super();
  }
}

export class CopyReportFailed extends Reference implements Action {
  readonly type = ReportActionTypes.COPY_REPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadFlexBoundaryCheck extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_FLEX_BOUNDARY_CHECK;

  constructor(
    public tableId: string,
    public reportId: string,
    public payload: FlexBoundaryCheck
  ) {
    super();
  }
}

export class LoadFlexBoundaryCheckSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_FLEX_BOUNDARY_CHECK_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public payload: FlexBoundaryCheckResponse
  ) {
    super();
  }
}

export class LoadFlexBoundaryCheckFailed extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_FLEX_BOUNDARY_CHECK_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadFlexDataRequest extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_FLEXDATA_REQUEST;

  constructor(
    public tableId: string,
    public reportId: string,
    public payload: FlexDataRequest
  ) {
    super();
  }
}

export class LoadFlexDataRequestSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_FLEXDATA_REQUEST_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public payload: Array<Array<any>>
  ) {
    super();
  }
}

export class LoadFlexDataRequestFailed extends Reference implements Action {
  readonly type = ReportActionTypes.LOAD_FLEXDATA_REQUEST_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class Reset implements Action {
  readonly type = ReportActionTypes.RESET;

  constructor() {}
}

export class CreateTrainModel implements Action {
  readonly type = ReportActionTypes.CREATE_TRAIN_MODEL;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class CreateTrainModelSuccess implements Action {
  readonly type = ReportActionTypes.CREATE_TRAIN_MODEL_SUCCESS;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class CreateTrainModelFailed implements Action {
  readonly type = ReportActionTypes.CREATE_TRAIN_MODEL_FAILED;
  constructor(public payload: any) {}
}

export class getMlTrainedModelResult implements Action {
  readonly type = ReportActionTypes.GET_TRAINED_MODEL_RESULTS;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class getMlTrainedModelResultSuccess implements Action {
  readonly type = ReportActionTypes.GET_TRAINED_MODEL_RESULTS_SUCCESS;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class getMlTrainedModelResultFailed implements Action {
  readonly type = ReportActionTypes.GET_TRAINED_MODEL_RESULTS_FAILED;
  constructor(public payload: any) {}
}

export class predictMlTrainedModel implements Action {
  readonly type = ReportActionTypes.PREDICT_ML_TRAINED_MODEL;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class predictMlTrainedModelSuccess implements Action {
  readonly type = ReportActionTypes.PREDICT_ML_TRAINED_MODEL_SUCCESS;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class predictMlTrainedModelFailed implements Action {
  readonly type = ReportActionTypes.PREDICT_ML_TRAINED_MODEL_FAILED;
  constructor(public payload: any) {}
}

export class CreateCompVisionModel implements Action {
  readonly type = ReportActionTypes.CREATE_COMP_VISION_MODEL;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class CreateCompVisionModelSuccess implements Action {
  readonly type = ReportActionTypes.CREATE_COMP_VISION_MODEL_SUCCESS;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class CreateCompVisionModelFailed implements Action {
  readonly type = ReportActionTypes.CREATE_COMP_VISION_MODEL_FAILED;
  constructor(public payload: any) {}
}

export class PredictCompVisionModel implements Action {
  readonly type = ReportActionTypes.PREDICT_COMP_VISION_MODEL;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class PredictCompVisionModelSuccess implements Action {
  readonly type = ReportActionTypes.PREDICT_COMP_VISION_MODEL_SUCCESS;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class PredictCompVisionModelFailed implements Action {
  readonly type = ReportActionTypes.PREDICT_COMP_VISION_MODEL_FAILED;
  constructor(public payload: any) {}
}

export class GetChatMessage implements Action {
  readonly type = ReportActionTypes.Get_CHAT_MESSAGE;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class GetChatMessageSuccess implements Action {
  readonly type = ReportActionTypes.Get_CHAT_MESSAGE_SUCCESS;
  constructor(
    public message:any,
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class GetChatMessageFailed implements Action {
  readonly type = ReportActionTypes.Get_CHAT_MESSAGE_FAILED;
  constructor(public payload: any) {}
}

export class GetChatPdf implements Action {
  readonly type = ReportActionTypes.Get_CHAT_PDF;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number,
    public fieldId: number,
    public recordId: number
  ) {}
}

export class GetChatPdfSuccess implements Action {
  readonly type = ReportActionTypes.Get_CHAT_PDF_SUCCESS;
  constructor(
    public message:any,
    public payload: any,
    public tableId: string,
    public reportId: number,
    public fieldId: string,
    public recordId: number
  ) {}
}

export class GetChatPdfFailed implements Action {
  readonly type = ReportActionTypes.Get_CHAT_PDF_FAILED;
  constructor(public payload: any) {}
}
export class GetFuzzyMatch implements Action {
  readonly type = ReportActionTypes.FUZZY_MATCH;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class GetFuzzyMatchSuccess implements Action {
  readonly type = ReportActionTypes.FUZZY_MATCH_SUCCESS;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class GetFuzzyMatchFailed implements Action {
  readonly type = ReportActionTypes.FUZZY_MATCH_FAILED;
  constructor(public payload: any) {}
}
export class CloseChatBot implements Action {
  readonly type = ReportActionTypes.CLOSE_CHAT_BOT;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number,
  ) {}
}

export class CloseChatBotSuccess implements Action {
  readonly type = ReportActionTypes.CLOSE_CHAT_BOT_SUCCESS;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number
  ) {}
}

export class CloseChatBotFailed implements Action {
  readonly type = ReportActionTypes.CLOSE_CHAT_BOT_FAILED;
  constructor(public payload: any) {}
}
export class CloseChatPdf implements Action {
  readonly type = ReportActionTypes.CLOSE_CHAT_PDF;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number,
    public recordId: number,
    public fieldId: number,
  ) {}
}

export class CloseChatPdfSuccess implements Action {
  readonly type = ReportActionTypes.CLOSE_CHAT_PDF_SUCCESS;
  constructor(
    public payload: any,
    public tableId: string,
    public reportId: number,
    public recordId: number,
    public fieldId: number,
  ) {}
}

export class CloseChatPdfFailed implements Action {
  readonly type = ReportActionTypes.CLOSE_CHAT_PDF_FAILED;
  constructor(public payload: any) {}
}

export class SaveDependencyLinks extends Reference implements Action {
  readonly type = ReportActionTypes.SAVE_DEPENDENCY_LINKS;
  constructor(
    public payload: any,
  ) {
    super();
  }
}

export class SaveDependencyLinksSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.SAVE_DEPENDENCY_LINKS_SUCCESS;
  constructor(
    public payload: any,
  ) {
    super();
  }
}

export class SaveDependencyLinksFailed extends Reference implements Action {
  readonly type = ReportActionTypes.SAVE_DEPENDENCY_LINKS_FAILED;
  constructor(public payload: any) {
    super();
  }
}

export class SaveGanttBaselines extends Reference implements Action {
  readonly type = ReportActionTypes.SAVE_GANTT_BASELINES;
  constructor(
    public payload: any,
  ) {
    super();
  }
}

export class SaveGanttBaselinesSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.SAVE_GANTT_BASELINES_SUCCESS;
  constructor(
    public payload: any,
  ) {
    super();
  }
}

export class SaveGanttBaselinesFailed extends Reference implements Action {
  readonly type = ReportActionTypes.SAVE_GANTT_BASELINES_FAILED;
  constructor(public payload: any) {
    super();
  }
}

export class BulkUpdateReports extends Reference implements Action {
  readonly type = ReportActionTypes.BULK_UPDATE_REPORTS;
  constructor(
    public payload: any,
  ) {
    super();
  }
}

export class BulkUpdateReportsSuccess extends Reference implements Action {
  readonly type = ReportActionTypes.BULK_UPDATE_REPORTS_SUCCESS;
  constructor(
    public payload: any,
  ) {
    super();
  }
}

export class BulkUpdateReportsFailed extends Reference implements Action {
  readonly type = ReportActionTypes.BULK_UPDATE_REPORTS_FAILED;
  constructor(public payload: any) {
    super();
  }
}
/**
 * Available types
 */
export type Actions =
  | LoadReports
  | LoadReportsSuccess
  | LoadReportsFailed
  | LoadReportFields
  | LoadReportFieldsSuccess
  | LoadReportFieldsFailed
  | CreateDTReport
  | CreateDTReportSuccess
  | CreateDTReportFailed
  | UpdateDTReport
  | UpdateDTReportSuccess
  | UpdateDTReportFailed
  | CreateGanttReport
  | CreateGanttReportSuccess
  | CreateGanttReportFailed
  | UpdateGanttReport
  | UpdateGanttReportSuccess
  | UpdateGanttReportFailed
  | LoadReportWithFilters
  | LoadReportWithFiltersSuccess
  | LoadReportWithFiltersFailed
  | DeleteReport
  | DeleteReportSuccess
  | DeleteReportFailed
  | LoadDatatable
  | LoadDatatableSuccess
  | LoadDatatableFailed
  | LoadFlexdata
  | LoadFlexdataSuccess
  | LoadFlexdataFailed
  | LoadSummaryReport
  | LoadSummaryReportSuccess
  | LoadSummaryReportFailed
  | LoadFlexChartTypes
  | LoadFlexChartTypesSuccess
  | LoadFlexChartTypesFailed
  | LoadDetails
  | LoadDetailsSuccess
  | LoadDetailsFailed
  | LoadColumns
  | LoadColumnsSuccess
  | LoadColumnsFailed
  | UpdateDefaultReport
  | UpdateDefaultReportSuccess
  | UpdateDefaultReportFailed
  | CreateCalendarReport
  | CreateCalendarReportSuccess
  | CreateCalendarReportFailed
  | UpdateCalendarReport
  | UpdateCalendarReportSuccess
  | UpdateCalendarReportFailed
  | CreateMapReport
  | CreateMapReportSuccess
  | CreateMapReportFailed
  | UpdateMapReport
  | UpdateMapReportSuccess
  | UpdateMapReportFailed
  | LoadSeriesFields
  | LoadSeriesFieldsSuccess
  | LoadSeriesFieldsFailed
  | LoadCalendarData
  | LoadCalendarDataSuccess
  | LoadCalendarDataFailed
  | LoadMapData
  | LoadMapDataSuccess
  | LoadMapDataFailed
  | CopyReport
  | CopyReportSuccess
  | CopyReportFailed
  | LoadGanttData
  | LoadGanttDataSuccess
  | LoadGanttDataFailed
  | LoadFlexBoundaryCheck
  | LoadFlexBoundaryCheckSuccess
  | LoadFlexBoundaryCheckFailed
  | LoadFlexDataRequest
  | LoadFlexDataRequestSuccess
  | LoadFlexDataRequestFailed
  | CreateTrainModel
  | CreateTrainModelSuccess
  | CreateTrainModelFailed
  | getMlTrainedModelResult
  | getMlTrainedModelResultSuccess
  | getMlTrainedModelResultFailed
  | predictMlTrainedModel
  | predictMlTrainedModelSuccess
  | predictMlTrainedModelFailed
  | CreateCompVisionModel
  | CreateCompVisionModelSuccess
  | CreateCompVisionModelFailed
  | PredictCompVisionModel
  | PredictCompVisionModelSuccess
  | PredictCompVisionModelFailed
  | GetChatMessage
  | GetChatMessageSuccess
  | GetChatMessageFailed
  | GetChatPdf
  | GetChatPdfSuccess
  | GetChatPdfFailed
  | GetFuzzyMatch
  | GetFuzzyMatchSuccess
  | GetFuzzyMatchFailed
  | CloseChatBot
  | CloseChatBotSuccess
  | CloseChatBotFailed
  | CloseChatPdf
  | CloseChatPdfSuccess
  | CloseChatPdfFailed
  | SaveDependencyLinks
  | SaveDependencyLinksSuccess
  | SaveDependencyLinksFailed
  | SaveGanttBaselines
  | SaveGanttBaselinesSuccess
  | SaveGanttBaselinesFailed
  | BulkUpdateReports
  | BulkUpdateReportsSuccess
  | BulkUpdateReportsFailed
  | Reset;
